var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step4" }, [
    _c("div", { staticClass: "input-con" }, [
      _c("table", { staticClass: "input-table" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("tr", [
          _c("td", [
            _c(
              "div",
              { staticClass: "w-full p-2 flex rounded-md shadow-sm" },
              [
                _c("editor", {
                  attrs: {
                    "api-key":
                      "skv2keu22mkkh9x439gwsx3neyd7hd023ff8m5iofqifchs4",
                    init: {
                      height: 300,
                      menubar: false,
                      plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "insertdatetime media table paste code help wordcount"
                      ],
                      toolbar:
                        "undo redo | formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | help"
                    }
                  },
                  model: {
                    value: _vm.specialInstructions,
                    callback: function($$v) {
                      _vm.specialInstructions = $$v
                    },
                    expression: "specialInstructions"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "button-con" },
      [
        _c("CButton", {
          attrs: { color: "green", text: "Next" },
          on: { click: _vm.onNextClick }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml20" },
          [
            _c("CButton", {
              attrs: { color: "orange", text: "Back" },
              on: { click: _vm.onBack }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml20" },
          [
            _c("CButton", {
              attrs: { color: "red", text: "Cancel" },
              on: { click: _vm.onCancel }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("td", [_vm._v("Special Instructions:")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }